import React, { useEffect, useState } from "react";
// interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
//   placeholderImg?: string;
//   errorImg?: string;
// }
export default ({ src, placeholderImg, errorImg, ...props }) => {
  const [imgSrc, setSrc] = useState(placeholderImg || src);
  useEffect(() => {
    const img = new Image();
    img.src = src;
    img.addEventListener("load", () => {
      setSrc(src);
    });
    img.addEventListener("error", () => {
      setSrc(errorImg || placeholderImg);
    });
  }, [src, placeholderImg, errorImg]);
  return (
    <img
      {...props}
      src={imgSrc}
      style={{
        padding: "15px",
      }}
    />
  );
};
